module.exports = __webpack_public_path__ + "static/media/Comments.8c3d5d2c.svg";